import cx from 'classnames';
import { getLocale } from 'umi';
import Preview from './Preview';
import './index.less';

const prefix = 'beukay-footer';

const getCx = (className: string) => `${prefix}-${className}`;
const getIcon = (index: number) =>
  `https://file.meilisci.com/resource/footer-icon-white-${index}.png`;
const services = [
  {
    key: 1,
    title: '品类齐全 轻松购物',
    desc: 'Complete Range Of Easy Shopping',
  },
  {
    key: 2,
    title: '多仓直发 极速配送',
    desc: 'Multi-warehouse Straight-up Delivery  Speed',
  },
  {
    key: 3,
    title: '正品行货 精致服务',
    desc: 'Genuine Licensed Exquisite Service',
  },
  {
    key: 4,
    title: '天天比价 畅选无忧',
    desc: 'Price Comparison Every Day Without Worry',
  },
];

const links = [
  {
    name: '上海创元化妆品有限公司报告查询系统',
    link: 'https://coa.beukay.com/Pc/#/home',
  },
];

const Footer = () => {
  const locale = getLocale();
  const isCN = locale === 'zh_CN';

  return (
    <footer className={cx(prefix)}>
      <div className={getCx('wrapper')}>
        <div className={getCx('content')}>
          <div className={getCx('services')}>
            {services.map((service) => (
              <div key={service.key} className={getCx('service-item')}>
                <img
                  className={getCx('service-item-icon')}
                  src={getIcon(service.key)}
                  alt="beukay_logo"
                />
                <span className={getCx('service-item-title')}>
                  {service.title}
                </span>
                <span className={getCx('service-item-desc')}>
                  {service.desc}
                </span>
              </div>
            ))}
          </div>
          <div className={getCx('divide')} />
          {isCN && (
            <div className={getCx('links')}>
              <div className={getCx('links-label')}>友情链接：</div>
              <div className={getCx('links-items')}>
                {links.map((item) => (
                  <a
                    href={item.link}
                    key={item.name}
                    className={getCx('links-item')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
              <a
                className={getCx('copyright-link pl-[20px]')}
                target="_blank"
                rel="noreferrer"
                href="https://mallsso.beukaymeta.com/"
              >
                创元美妆生态平台
              </a>
            </div>
          )}
          <div className={`${getCx('copyright')}`}>
            <span className="flex items-center">
              <img
                className="w-[16px] h-[16px] mr-[4px] inline-block"
                src="http://file.meilisci.com/1717741739755_online-gov.png"
                alt="online-gov"
              />
              <a
                className={getCx('copyright-link')}
                href="https://beian.mps.gov.cn/#/query/webSearch?code=31011202020277"
                target="_blank"
                rel="noreferrer"
              >
                沪公网安备31011202020277
              </a>
            </span>
            <span>
              ICP备案序号：
              <a
                className={getCx('copyright-link')}
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noreferrer"
              >
                沪ICP备2022029269号-3
              </a>
            </span>
            {isCN && (
              <Preview src="https://file.meilisci.com/resource/business-license.png">
                企业法人营业执照经营许可证
              </Preview>
            )}
            <span>
              {isCN
                ? '技术支持：上海美砺科技有限公司'
                : 'Tech Support：Shanghai Meili Technology Co., Ltd'}
            </span>
            <span>
              {isCN
                ? '©️2023 Beukaymeta 版权所有'
                : '© 2023 Beukaymeta.com. All rights reserved.'}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
